// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CKAe","rootNoMargin":"styles_rootNoMargin__2x4v7"};